module.exports = __webpack_public_path__ + "static/media/undraw_scrum_board_cesn.fd1f6093.svg";